import _ from 'lodash'
import React, { Component } from 'react'
import autoBind from 'react-autobind'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { bindActionCreators } from 'redux'
import { Accordion, Container, Image, Label, Segment } from 'semantic-ui-react'
import ReactLoading from 'react-loading'

import angle from '../../assets/images/angle.png'
import { tr } from '../../helpers/languages'
import { send } from '../../helpers/requests'
import { format } from '../../helpers/timezones'
import ParticipantSession from '../participant-session'
import { actions as participants } from '../../store/actions/participants'

class ParticipantSessions extends Component {
    constructor (props) {
        super(props)
        this.state = {
            index: -1,
            loading: false
        }
        autoBind(this)
    }

    componentDidMount () {
        const { userTokens } = this.props

        if (userTokens.accessToken.token) {
            this.ensureSessionsLoaded()
        }
    }

    componentWillReceiveProps (nextProps) {
        // Re-fetch if token changes.
        if (nextProps.userTokens.accessToken.token !== this.props.userTokens.accessToken.token) {
            this.ensureSessionsLoaded()
        }
    }

    ensureSessionsLoaded () {
        const participant_a0 = this.props.match.params.id
        const cachedSessions = this.props.participant_sessions[participant_a0]

        if (Array.isArray(cachedSessions) && cachedSessions.length > 0) {
            console.log(`Using cached sessions for ${participant_a0}`)
            return
        }

        this.fetchSessions()
    }

    // Fetches the patient's sessions.
    fetchSessions () {
        const participant_a0 = this.props.match.params.id
        // eslint-disable-next-line no-console
        console.log('Fetch sessions.')
        this.setState({
            loading: true
        })
        send({
            method: 'GET',
            tokens: this.props.userTokens,
            url: `/patients/${participant_a0}/program`
        })
            .then((response) => {
                // eslint-disable-next-line no-console
                console.log('Fetched sessions.')
                const data = response.data
                this.props.setParticipantSessions({ participant_a0, value: data })
                this.setState({
                    loading: false
                })
            })
            .catch((error) => {
                // Failed to fetch sessions.
                // eslint-disable-next-line no-console
                console.error('Failed to fetch sessions.', error)
                // Hide the error.
            })
    }

    // Toggles the session at the given index.
    toggleSession (index) {
        this.setState({ index: this.state.index === index ? -1 : index })
    }

    render () {
        const participant_a0 = this.props.match.params.id
        const sessions = this.props.participant_sessions[participant_a0] || []
        return (
            <Container className='participant-sessions'>
                {this.state.loading
                    ? <div className='session-loader'>
                        <ReactLoading type='spin' color='#444'/>
                    </div>
                    : <div className='l4' ref={(c) => { this.l4c = c }}>
                        <Accordion>
                            {
                                _.flattenDeep(sessions.map((session, index) => {
                                    return [(
                                        <Accordion.Title
                                            key={`session${session.id}-title`}
                                            active={this.state.index === index}
                                            index={index}
                                            onClick={(_e, { index }) => { this.toggleSession(index) }}
                                        >
                                            <Segment.Group horizontal className={`session ${session.status}`}>
                                                <Segment width={3} className='session-title'>{session.title}</Segment>
                                                <Segment width={2} className='session-start'>
                                                    {
                                                        _.isEmpty(session.start) ? ''
                                                            : format(session.start, 'DD/MM/YYYY', this.props.timezone, this.props.language)
                                                    }
                                                </Segment>
                                                {
                                                    session.status !== 'locked' && (
                                                        <Segment width={9} className='session-status'>
                                                            <Label>{tr(session.status === 'completed' ? 'COMPLETED' : 'CURRENT_SESSION')}</Label>
                                                        </Segment>
                                                    )
                                                }
                                                {
                                                    session.status !== 'locked' && (
                                                        <Segment
                                                            width={2}
                                                            className='session-expand-collapse'
                                                        >
                                                            <Image src={angle}
                                                                   className={this.state.index === index ? 'collapse' : 'expand'}/>
                                                        </Segment>
                                                    )
                                                }
                                            </Segment.Group>
                                        </Accordion.Title>
                                    )].concat(this.state.index !== index ? [] : [(
                                        <Accordion.Content
                                            key={`session${session.id}-content`}
                                            active={this.state.index === index}
                                            className='session-details'
                                        >
                                            <ParticipantSession
                                                id={session.id}
                                                status={session.status}
                                            />
                                        </Accordion.Content>
                                    )])
                                }))
                            }
                        </Accordion>
                    </div>
                }
            </Container>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        language: state.settings.language,
        timezone: state.settings.timezone,
        userTokens: state.users.userTokens,
        participant_sessions: state.participants.participant_sessions
    }
}

const mapDispatchToProps = (_dispatch) => {
    const _participants = bindActionCreators(participants, _dispatch)
    return {
        setParticipantSessions: _participants.setParticipantSessions
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ParticipantSessions))



// WEBPACK FOOTER //
// ./src/components/participant-sessions/index.js